import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Redirect,
    Route,
  } from 'react-router-dom';
  
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner'
import classes from './AppRouter.module.css';
//import { LoginScreen } from '../components/auth/LoginScreen';


// import { TheLayout } from '../containers';
//import { CalendarScreen } from '../components/calendar/CalendarScreen';
import Admin from "../layouts/Admin.js";

//import { startChecking } from '../actions/auth';
import { startChecking, startLogout } from '../store/auth-actions'
import { calculateRemainingTime} from '../helpers/fetch';


import SignIn1 from '../components/Authentication/SignIn1';

import { useHistory } from 'react-router-dom';

let logoutTimer;

/* function logoutHandler() {
    alert("Happy Birthday");
    dispatch( startLogout());
    history.replace('/login');
} */


export const AppRouter = () => {
    //const token = sessionStorage.getItem('token') || '';
    const dispatch = useDispatch();
    const { checking, isLoggedin, tokenExpiresIn } = useSelector( state => state.auth);
    const history = useHistory();

    //const [token, setToken] = useState();
    

    useEffect(() => {
       dispatch( startChecking());
       console.log("startChecking Useeffect AppRouter");
    }, [dispatch])


    useEffect(() => {
        if (isLoggedin){
            const remainingTime = calculateRemainingTime(tokenExpiresIn);
            console.log("tokenExpires in in AppRouter:", tokenExpiresIn);
            console.log("remaining time in AppRouter:", remainingTime);
            logoutTimer = setTimeout(
                
                () => {
    
                    sessionStorage.clear();
                    dispatch( startLogout());
                   // history.replace('/login');
                    
                }
                
                , remainingTime);
            //logoutTimer = setTimeout(dispatch( startLogout()), 10000);
        }
     }, [tokenExpiresIn])

    if ( checking ) {
        //const str = uid; 
        return (
            <div className={classes.loading} width="100%">
                <LoadingSpinner />
            </div>
            );
    }

    return (
        <Router>
            <div>
                <Switch>
                    
                    <Route path='/login' exact>
                        {isLoggedin ? <Redirect to='/admin' /> : <SignIn1 />}
                    </Route>
                    <Route path='/admin'>
                        {isLoggedin ? <Admin /> : <Redirect to='/login' />}
                    </Route>
                    <Route path='*'>
                        <Redirect to='/login' />
                    </Route>

        
                </Switch>
            </div>
        </Router>
    )
}
